<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Campaign List</h4>
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a
                ref="collapseHeader"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Collapse"
                @click="toggleCollapse(collapseHeader.value)"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
              href="javascript:void(0);"
              class="btn btn-added"
              @click="addNewCampaign"
          >
            <!--              @click="openModal('new')"-->
            <vue-feather type="plus-circle" class="me-2"></vue-feather>
            Add Campaign
          </a>
        </div>
      </div>
      <!-- USER TABLE -->
      <filter-table
          :extra-class="['table', 'datanew']"
          :columns="campaigns.columns"
          :data="campaigns.data.value"
          :filters="campaigns.filters"
      >
        <template #header>
          <h4>Campaigns</h4>
        </template>


        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'image'">
            <div class="">
              <a href="javascript:void(0);" class="">
                <Avatar
                    :src="record.thumbnail?.url"
                    :alt="record.type"
                    img-class="user-image"
                />
              </a>

            </div>
          </template>

          <template v-else-if="column.key === 'amount'">
            {{ formatAmount(record.amount, true) }}
          </template>

          <template v-else-if="column.key === 'amount_raised'">
            {{ formatAmount(record.amount_raised, true) }}
          </template>

          <template v-else-if="column.key === 'start_date'">
            {{ formatDateTime(record.start_date) }}
          </template>

          <template v-else-if="column.key === 'end_date'">
            {{ formatDateTime(record.end_date) }}
          </template>

          <template v-else-if="column.key === 'status'">
            <a-switch
                :checked="record.status"
                @change="updateStatus(record.id)"
            />
          </template>

          <template v-if="column.key === 'action'">
            <td class="action-table-data">
              <div class="edit-delete-action">

                <a
                    @click="editCampaign(record?.id)"
                    class="me-2 p-2 mb-0"
                    href="javascript:void(0);"
                    title="View"
                >
                  <i data-feather="edit" class="feather-edit"></i>
                </a>

                <!-- View -->
                <a
                    @click="viewCampaign(record)"
                    class="me-2 p-2 mb-0"
                    href="javascript:void(0);"
                    title="View"
                >
                  <i data-feather="eye" class="feather-eye"></i>
                </a>
              </div>
            </td>
          </template>

        </template>

        <!-- </template> -->
      </filter-table>
      <!-- USER TABLE -->
    </div>
  </div>

  <CampaignModal :campaign="campaign"/>

</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useCampaignStore} from "@/store/campaignStore";
import {toggleCollapse} from "@/utils/components";
import Avatar from "@/components/avatar.vue";
import {useRouter} from "vue-router";
import {encodeUrlData} from "@/views/pages/Campaign/utils/data";
import {formatAmount} from "@/utils";
import CampaignModal from "@/views/pages/modals/CampaignModal.vue";

const campaignStore = useCampaignStore();
const router = useRouter();
const collapseHeader = ref(null);
const campaign = ref(null);


const campaigns = {
  filters: ["type", "start_date", "end_date"],
  columns: [
    {
      title: "Campaign Banner",
      dataIndex: "thumbnail?.url",
      key: "image",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: {
        compare: (a, b) => {
          a = a.type.toLowerCase();
          b = b.type.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: {
        compare: (a, b) => {
          return Number(a.amount || 0) - Number(b.amount || 0);
        },
      },
    },
    {
      title: "Amount Raised",
      dataIndex: "amount_raised",
      key: "amount_raised",
      sorter: {
        compare: (a, b) => {
          return Number(a.amount_raised || 0) - Number(b.amount_raised || 0);
        },
      },
    },
    {
      title: "Start date",
      dataIndex: "start_date",
      key: "start_date",
      sorter: {
        compare: (a, b) => {
          a = a.start_date.toLowerCase();
          b = b.start_date.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      sorter: {
        compare: (a, b) => {
          a = a.end_date.toLowerCase();
          b = b.end_date.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Is Active",
      dataIndex: "status",
      key: "status",
      sorter: {
        compare: (a, b) => {
          return Number(a.status) - Number(b.status);
        },
      },
    },

    {
      title: "Action",
      key: "action",
      sorter: true,
    },
  ],
  data: computed(() => campaignStore.campaigns),
};

function addNewCampaign() {
  router.push({name: "add-campaign"});
}

const encodedData = (id) => encodeUrlData(id);

function editCampaign(campaignId){
  router.push({name: "edit-campaign", params: { encodedData: encodedData(campaignId)}});
}
function formatDateTime(date) {
  if (!date) return "-";

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "-";
  }

  return parsedDate.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

function viewCampaign(selectedCampaign)
{
  campaign.value = {
    ...selectedCampaign,

    media_item_url:
        selectedCampaign.media_item_url ||
        selectedCampaign.thumbnail?.url ||
        null,

  };

  $("#campaignModal").modal("show");
}

async function updateStatus(campaignId) {
  await campaignStore.updateCampaignStatus(campaignId);
}

onMounted(async () => {
  await campaignStore.fetchCampaigns();
});
</script>

<style>

</style>